import React from 'react';
import { AppRouteProps } from '~/routes';
import Create from './pages/Create';
import Index from './pages/Index';
import Edit from './pages/Edit';

export default function ResourcesWorkShift(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/work-shift',
      component: Index,
      isProtected: true,
      permissions: ['work_shift_index'],
    },
    {
      path: '/work-shift/create',
      component: Create,
      isProtected: true,
      permissions: ['work_shift_create'],
    },
    {
      path: '/work-shift/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['work_shift_edit'],
    },
  ];

  return routes;
}